import { FC, useState } from 'react';
import { Form, Tabs } from 'antd';

import {
	useAppSelector,
	useHorizontalScroll,
	useInitialSearchParams,
	useTranslate,
	useDebouncedChange,
} from 'hooks';

import { FundedProjects } from './FundedProjects';
import { FinishedLoans } from './FinishedLoans';

import { selectUser } from 'selectors';

import s from './index.module.scss';

export const MyInvestments: FC = () => {
	const requestStatus = useAppSelector((state) => state.myInvestments.status);
	const user = useAppSelector(selectUser);
	const [type, setType] = useState('fundedProjects');

	const { fundedProjectsText, finishedInvestmentsText } = useTranslate([
		'fundedProjectsText',
		'finishedInvestmentsText',
	]);

	const [form] = Form.useForm();
	const watchedValues = Form.useWatch([], form);

	const { values } = useDebouncedChange(watchedValues);
	const { initialValues, setSearchParams } = useInitialSearchParams({ values });
	useHorizontalScroll(requestStatus);

	return (
		<div className={s.myInvestments}>
			<Tabs
				className="accountTabs"
				type="card"
				defaultActiveKey={type}
				activeKey={type}
				onChange={(v: string) => {
					setSearchParams({});
					form.setFieldsValue({
						type: [],
						riskLvl: [],
						loanId: undefined,
						projectTitle: undefined,
						originatorTitle: undefined,
						'interestRate[from]': undefined,
						'interestRate[to]': undefined,
						'investedAmount[from]': undefined,
						'investedAmount[to]': undefined,
						'ltv[from]': undefined,
						'ltv[to]': undefined,
						isPurchased: undefined,
						minDateOfPurchase: undefined,
						maxDateOfPurchase: undefined,
						overdueInterestPayments: undefined,
						lateLoans: undefined,
					});
					setType(v);
				}}
				destroyInactiveTabPane
			>
				<Tabs.TabPane
					tab={`${fundedProjectsText} (${user.currentInvestmentsQty})`}
					key="fundedProjects"
				>
					<FundedProjects initialValues={initialValues} form={form} values={values} type={type} />
				</Tabs.TabPane>
				<Tabs.TabPane
					tab={`${finishedInvestmentsText} (${user.finishedInvestmentsQty})`}
					key="finished"
				>
					<FinishedLoans initialValues={initialValues} form={form} values={values} type={type} />
				</Tabs.TabPane>
			</Tabs>
		</div>
	);
};
